/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {KitchenDramaSushiManiaGameAssets} from "../KitchenDramaSushiManiaGameAssets";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {gsap} from "gsap";
import {KitchenDramaSushiManiaGameMode} from "../server/KitchenDramaSushiManiaGameMode";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";

export class KitchenDramaSushiManiaBackgroundElements extends PIXI.Container implements StageLayer {

    private _backgroundContainer:PIXI.Container;
    private _backgroundMain:PIXI.Sprite;
    private _mainView:PIXI.Container;
    private _backgroundFS:PIXI.Sprite;
    private _logo:PIXI.Sprite;
    private _bgSmoke:TimelineSprite;
    private _smokeAnimation:gsap.core.Timeline;

    constructor() {
        super();
        this.name = "KitchenDramaSushiManiaBackgroundElements";
        this.init();
    }

    private init() {
        this._mainView = new PIXI.Container();
        this._backgroundContainer = new PIXI.Container();

        this._backgroundMain = new PIXI.Sprite(KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaSushiManiaGameAssets.MAIN_GAME_BACKGROUND)[0]);
        this._backgroundMain.position.set(360, 300);
        this._backgroundMain.scale.set(1.2,1.2);
        this._backgroundMain.anchor.set(0.5, 0.5);

        this._bgSmoke = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaSushiManiaGameAssets.SMOKE), 10);
        this._bgSmoke.position.set(-590,-90);
        this._bgSmoke.scale.set(1.5,1.5);
        this._backgroundMain.addChild(this._bgSmoke);
        this._smokeAnimation = gsap.timeline({repeat:-1});
        this._smokeAnimation.add(this._bgSmoke.getAnimation());
        this._smokeAnimation.play();


        this._backgroundFS = new PIXI.Sprite(KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaSushiManiaGameAssets.FS_BACKGROUND)[0]);
        this._backgroundFS.position.set(360, 305);
        this._backgroundFS.scale.set(1.2,1.2);
        this._backgroundFS.anchor.set(0.5, 0.5);

        this._backgroundContainer.addChild(this._backgroundMain);
        this._backgroundContainer.position.set(0, 0);

        this._logo = new PIXI.Sprite(KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaSushiManiaGameAssets.LOGO)[0]);
        this._logo.anchor.set(0.5,0);

        this._mainView.addChild(this._backgroundContainer);
        this._mainView.addChild(this._logo);
        this.addChild(this._mainView);

        this.onOrientationChanged();
        this.onResize();
    }

    public onOrientationChanged() {
        if (NolimitApplication.isLandscape){
            this._logo.position.set(360, 0);
            this._logo.scale.set(0.5,0.5);
        }
        else {
            this._logo.scale.set(0.75,0.75);
            this._logo.position.set(360, -245);
        }
    }

    public onResize() {

    }

    private swapBackgroundTo(newBackground:PIXI.Sprite) {
        this._backgroundContainer.addChildAt(newBackground, 0);
        if (this._backgroundContainer.children.length > 1) {
            this._backgroundContainer.removeChildren(1);
        }
    }

    public setMode(mode:string) {
        if (mode == KitchenDramaSushiManiaGameMode.WILD_SUSHI) {
            this.swapBackgroundTo(this._backgroundFS);
        } else {
            this.swapBackgroundTo(this._backgroundMain);
        }
    }
}